import ContentType from '../model/contentType';

class MicroAppPagesCollection {
    constructor(views) {
        this.microAppViewPages = views;
        this.selectedContentVersionId = null;
        this.isMicroApp = false;
    }

    static getInstance(views) {
        if (!MicroAppPagesCollection.instance) {
            MicroAppPagesCollection.instance = new MicroAppPagesCollection(views);
            return MicroAppPagesCollection.instance;
        }

        return MicroAppPagesCollection.instance;
    }

    get contentVersionId() {
        return this.selectedContentVersionId;
    }

    set contentVersionId(value) {
        this.selectedContentVersionId = value;
    }

    get isTiled() {
        return this.isMicroApp;
    }

    set isTiled(value) {
        this.isMicroApp = value;
    }

    getScreenPageInfo(screenId) {
        if (!this.microAppViewPages) {
            return {
                documentPageIndex: 0,
                pageIndex: 0
            };
        }

        const currenTiled = this.microAppViewPages.find(c => c.externalUniqueId === this.selectedContentVersionId);
        const pages = (currenTiled && currenTiled.pages) || [];
        const currentPage = pages.find(item => item.screenId === screenId);

        if (currentPage) {
            return {
                documentPageIndex: currentPage.documentPageIndex || 0,
                pageIndex: currentPage.index || 0
            };
        }

        return {
            documentPageIndex: 0,
            pageIndex: 0
        };
    }
}

export const buildTiledPreViewRequest = (contents) => {
    const microAppContents = contents.filter(content => content.format === ContentType.MICROAPP);
    return microAppContents.map(content => content.contentClass);
};

export default MicroAppPagesCollection;
